import { SearchStyle } from '../../Config';
import { ActionTypes as SearchActionTypes } from '../../actions/search';
import { ActionTypes as PageActionTypes } from '../../actions/page';
import { transformResult } from './utils';
export const initialState = {
    searchStyle: SearchStyle.dropdown,
    inputValue: '',
    searchedTerm: '',
    isFetching: false,
    results: null,
    totalCount: null,
    currentPage: null,
    totalPages: null,
    isOpen: false,
};
const searchDropdownReducer = (state = initialState, action) => {
    switch (action.type) {
        case PageActionTypes.PAGE_NAV_COMPLETE: {
            return initialState;
        }
        case SearchActionTypes.SEARCH_INPUT_CHANGED: {
            return {
                ...initialState,
                // Only for search as you type...
                searchedTerm: '',
                inputValue: action.payload.searchTerm,
                isOpen: !!action.payload.searchTerm.length,
            };
        }
        case SearchActionTypes.SEARCH_INPUT_FOCUSSED: {
            return {
                ...state,
                isOpen: !!state.inputValue.length,
            };
        }
        case SearchActionTypes.SEARCH_INPUT_BLURRED: {
            return {
                ...state,
                isOpen: false,
            };
        }
        case SearchActionTypes.SEARCH_RESET: {
            return { ...initialState };
        }
        case SearchActionTypes.SEARCH_FETCH_STARTED: {
            const searchedTerm = action.payload.query;
            return { ...state, searchedTerm, isFetching: true };
        }
        case SearchActionTypes.SEARCH_FAIL:
        case SearchActionTypes.SEARCH_CANCEL:
            return { ...state, isFetching: false };
        case SearchActionTypes.SEARCH_SUCCESS: {
            // If the resutls returned don't match up to what we searched for ignore...
            // the use has probably triggered a new search or cancelled.
            if (state.inputValue !== action.payload.searchedTerm) {
                return state;
            }
            return {
                ...state,
                inputValue: action.payload.searchedTerm,
                isFetching: false,
                results: action.payload.searchArticles.results.map((r) => transformResult(r, {
                    languageId: action.payload.languageId,
                    now: action.payload.now,
                })),
                searchedTerm: action.payload.searchedTerm,
                totalCount: action.payload.searchArticles.pageInfo.totalCount,
                currentPage: action.payload.searchArticles.pageInfo.currentPage,
                totalPages: action.payload.searchArticles.pageInfo.totalPages,
                isOpen: true,
            };
        }
    }
    return state;
};
export default searchDropdownReducer;
//# sourceMappingURL=dropdown.js.map